
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DetailDialog from '@/components/busi/table/detail.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { studySearch, studyDetail } from '@/api/baseinformation'
@Component({
  name: 'study-type-manage',
  components: {
    SimpleTable,
    DetailDialog,
    DictSelect
  }
})
export default class StudyTypeManage extends Vue {
  private form = {
    studyState: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'studyCode',
    label: '学习类型代码'
  },
  {
    prop: 'studyName',
    label: '学习类型名称'
  },
  {
    prop: 'studyState',
    label: '学习类型状态'
  },
  {
    prop: 'businessName',
    label: '业务名称'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    // do something
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await studySearch({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      studyState: 1
    }
    this.onQuery()
  }

  private visible = !1

  private detailData = {}

  private async showDetail (row: any) {
    await studyDetail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !0
        this.detailData = {
          studyCode: res.object.studyCode,
          studyName: res.object.studyName,
          studyState: res.object.studyState
        }
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
